import { connect } from 'react-redux';
import IAppState from "../../../IAppState";
import CustomMutantComponent from '../components/CustomMutantComponent';
import ActMain from '../../../act-main';
import IMainState from '../../../IMainState';
import { ICustomMutantPropsData, ICustomMutantPropsFunctions } from '../props/ICustomMutantProps';
import { ll_fetch } from '../../../tools';
import * as download from "downloadjs";


async function generateCustomMutantSequence(jobId: string, fileName: string, mutations: any ) {

    await ll_fetch(`/api/pdb/generateUserSequence?jobId=${jobId}&name=${fileName}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(mutations),
    })
    .then(r => {
        if (!r.ok) {
            alert("Unable generate the sequence.");
            return;
        }
        r.blob().then(data => {
            download(data, fileName, r.headers.get('Content-Type'));
        })
    })
    .catch(err => {
        console.error(err);
    })

}

function setCharAt(str,index,chr) {
    if(index > str.length-1) return str;
    return str.substring(0,index) + chr + str.substring(index+1);
}

const mapStateToProps = ({ jobState, mainState}: IAppState): ICustomMutantPropsData => ({
    CustomMutation : mainState.CustomMutantMutations, 
    fileName : "", 
    jobId: mainState.jobId
})

const mapDispatchToProps = (dispatch): ICustomMutantPropsFunctions => ({
    
    removeCustomMutantMutations: (mutation: any) => dispatch(ActMain.removeCustomMutantMutations(mutation)),
    generateCustomMutantSequence: (jobId: string, fileName: string, mutations: any) => generateCustomMutantSequence(jobId, fileName, mutations),
    clearMutations: () => dispatch(ActMain.clearMutations())
})


const CustomMutantContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(CustomMutantComponent)

export default CustomMutantContainer;
